import { PRODUCT_TYPES } from "@/lib/constants";

import type { PRODUCTS } from "@/lib/constants";

// round-robin distribution across n columns
export function splitIntoColumns<T>(items: readonly T[], columnCount: number): T[][] {
  const columns: T[][] = Array.from({ length: columnCount }, () => []);
  items.forEach((item, i) => columns[i % columnCount].push(item));
  return columns;
}

// chunk-based split: each column gets up to itemsPerColumn items
export function chunkIntoColumns<T>(items: readonly T[], itemsPerColumn = 9): T[][] {
  const columns: T[][] = [];
  for (let i = 0; i < items.length; i += itemsPerColumn) {
    columns.push(items.slice(i, i + itemsPerColumn) as T[]);
  }
  return columns;
}

export function withIkVideoQuality(url: string, quality = 50): string {
  if (!url || !url.includes("ik.imagekit.io")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}tr=q-${quality}`;
}

export const getProductHref = (product: (typeof PRODUCTS)[number]): string => {
  if (product.productKey === PRODUCT_TYPES.QUOTES || product.productKey === PRODUCT_TYPES.SCHEDULING) {
    return `/features/${product.slug}`;
  }
  if (product.isComingSoon) {
    return "#";
  }
  return `/#${product.slug}`;
};
